import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ContentReportTableMacroRendererProps } from '../src/ContentReportTableMacroRenderer.tsx';

export const ContentReportTableMacroHandler: LoadableType<ContentReportTableMacroRendererProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContentReportTableMacro" */ '../src/ContentReportTableMacroRenderer.tsx'
				)
			).ContentReportTableMacroRenderer,
	});
